      window.MeamaVisitor = {
        isLoggedIn: null,
        customerId: null,
        pageType: null,
        template: null,
        locale: null
      };